import styled from 'styled-components';

export const BreadcrumbContainer = styled.div`
  padding: 8px 0;
  width: 100%;
  max-width: 1400px;
  
  a {
    color: ${props => props.theme.colors.primary};
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;
